"use strict";

Kobo = Kobo || {};
Kobo.Breakpoints = Kobo.Breakpoints || {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};